import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'components/forms/DateTimePicker';
import moment from 'moment';

import { DATE_FORMAT, WEEK_DAYS } from 'constants/config';
import Tag from 'components/forms/Tag';
import CloseIcon from 'mdi-react/CloseIcon';
import Input from 'components/forms/Input';
import Error from 'components/forms/Error';
import PlusIcon from 'icons/plus';


class ExcludeDaysArray extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    fields: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {
      tempDate: null,
      hasErrors: false,
    };
  }

  setTempDate(tempDate) {
    this.setState({ tempDate });
  }

  handleAdd() {
    if (this.state.tempDate) {
      this.props.fields.push({ date: moment(this.state.tempDate).toISOString() });
      this.setState({ hasErrors: false, tempDate: null });
    } else {
      this.setState({ hasErrors: true });
    }
  }

  render() {
    return (
      <ul className="excluded-dates">
        <li>
          <div className="date-picker mr-2">
            <DateTimePicker
              selected={this.state.tempDate}
              showTimeSelect={false}
              // waiting to resolve https://github.com/Hacker0x01/react-datepicker/issues/1609
              dateFormat="yyyy-MM-dd"
              placeholderText="Add date to exclude"
              onChange={date => this.setTempDate(date)}
              customInput={<Input />}
            />
          </div>
          <PlusIcon onClick={() => this.handleAdd()} />
        </li>
        {this.state.hasErrors && <Error error="Required" />}
        {this.props.fields.getAll() && this.props.fields.getAll().map((day, index) =>
          (
            <li key={day.id || index}>
              <Tag label={moment(day.date).local().format(DATE_FORMAT)} color="primary" />
              {/* <span className="excluded-dates__item"> {moment(day.date).local().format(DATE_FORMAT)} </span> */}
              <CloseIcon className="excluded-dates__item-remove" onClick={() => this.props.fields.remove(index)} />
            </li>
          ))
        }
      </ul>
    );
  }
}


const renderDaysToSend = ({ fields, meta: { error, submitFailed } }) => (
  <React.Fragment>
    <div className="weekday-selector">
      <ul>
        {
          WEEK_DAYS.map(day => (
            // eslint-disable-next-line
            <li
              key={day}
              className={fields.getAll() && fields.getAll().includes(day) ? 'selected' : ''}
              onClick={() => {
                // currently selected days
                const daysToSend = fields.getAll(); // ex. ['monday', 'friday'] note, they are in correct order
                const isSelected = daysToSend && daysToSend.includes(day); // if weekday is selected
                if (isSelected) {
                  // if selected then we remove it from fields
                  // this is not a mutator; it dispatches an action which updates the state in Redux,
                  // which will cause your component to rerender.
                  fields.remove(daysToSend.indexOf(day));
                } else {
                  // if fields isn't selected then we need to insert (not a mutator also) in the fields array
                  // with correct order (example for 'wednesday' -> ['monday', 'wednesday', 'friday'])

                  const dayIndex = WEEK_DAYS.indexOf(day); // current day index
                  // find days to the rigth from current day
                  // (example for 'wednesday' -> ['thursday', 'friday', 'saturday'])
                  const daysToTheRight = WEEK_DAYS.slice(dayIndex + 1, WEEK_DAYS.length);

                  // bool which will control if toggled day or not
                  // if false -> user has selected day which doesn't have selected days to the right
                  // ex. user selected 'friday' and in daysToSend we have ['monday', 'wednesday']
                  let isInserted = false;

                  // searching for first weekday after daysToSend
                  for (let i = 0; i < daysToTheRight.length; i += 1) {
                    if (daysToSend.includes(daysToTheRight[i])) {
                      const pushToLeftFromIndex = daysToSend.indexOf(daysToTheRight[i]);
                      fields.insert(pushToLeftFromIndex, day);
                      isInserted = true;
                      break;
                    }
                  }

                  if (!isInserted) {
                    // we can add to the end of array because this weekday doesn't have selected days to the right
                    fields.push(day);
                  }
                }
              }}
            >
              <span>{day.substring(0, 3)}</span>
            </li>
          ))
        }
      </ul>
    </div>
    {submitFailed && error && <Error error={error} />}
  </React.Fragment>
);


renderDaysToSend.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fields: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    submitFailed: PropTypes.bool,
  }),
};


renderDaysToSend.defaultProps = {
  meta: PropTypes.shape({
    error: null,
    submitFailed: false,
  }),
  submitting: false,
  pristine: true,
};


export {
  ExcludeDaysArray,
  renderDaysToSend,
};
